import {createStandardAction} from "typesafe-actions";
import {ILevelMapTileProgress} from "../../game/types";

export const enterCardsGame = createStandardAction('@mini-games/ENTER_CARDS_GAME')();
export const leaveCardsGame = createStandardAction('@mini-games/LEAVE_CARDS_GAME')<Partial<ILevelMapTileProgress>>();
export const selectCard = createStandardAction('@mini-games/SELECT_CARD')<{cardIndex: number, isWon: boolean}>();